import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem/SliderListItem';

const VisualizerDriftRotationListItem = (props) => {
    const { rotation, updateVisualizerSettings } = props;

    const onRotationChange = (value) => updateVisualizerSettings({ drift: { rotation: value } });

    return (
        <SliderListItem
            title='Rotation'
            displayMultiplier={2.5}
            value={rotation}
            min={0}
            max={25}
            step={1}
            onValueChange={onRotationChange}
            toolTip='Maximum rotation in degrees.'
        />
    );
};

const mapStateToProps = (state) => {
    const { rotation } = state.createPreview.present.videoSettings.visualizer.drift;
    return { rotation };
};

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings };
};

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerDriftRotationListItem);
